import { Box, Button, Grid, Hidden, Skeleton, Theme, Typography, useTheme } from "@mui/material";
import { ChartIcon, CurrencyIcon, MoneyGrow, PercentageIcons } from "../../../assets/SvgIcons";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import CustomDropdown from "../../../lib/formik/CustomDropdown";
import { ErrorText } from "../../dashboard/chart/CustomeLineChart";
import CustomePieChart from "../../dashboard/chart/CustomePieChart";
import CustomTable from "../common/customTable";
import { QuantitativeAnalysisHead, QuantitativeAnalysisTable, TopSchemeTableHead, TopSchemTable } from "./common/Table";
import { useDispatch, useSelector } from "react-redux";
import { RootStateType } from "../../../redux-store/reducers";
import { Order, SortingObj, navigationData } from "../types";
import BreadCrum from "../../../lib/BreadCrum";
import InvestorLevelAMCPerformanceAnalysis from "../../dashboard/table/InvestorLevelAMCPerformance";
import { AMCPerformanceProductsRes, GetQuantitativeAnalysisResponseBody, GetTop10SchemesRes, MarketCapAllocationRes, PortfolioExposureMFRes, QuantitativeAnalysisData, TotalCardValuesRes, RatingAndMaturityRes, IssuerCategoryRes } from "../../../redux-store/types/products";
import { getMarketCapAllocation, getProductsAMCPerformance, getQuantitativeAnalysis, portfolioExposureInCategory, top10Schemes, totalCardValuesApi, getRatingAndMaturity, getIssuerCategoryAllocation } from "../../../redux-store/actions/product";
import { formatCurrency, isModuleAllowed } from "../../../utils/utilityFunctions";
import { USER_ROLES } from "../../../utils/constant";



type CardProps = {
    Icons: (props: React.SVGProps<SVGSVGElement>) => JSX.Element
    title: string
    value: string
    color?: string
    loading?: boolean
    percent?: boolean
    percentageValue?: number
}



const Card = (props: CardProps) => {
    const { Icons, title, value, color, loading, percent, percentageValue } = props
    const { palette } = useTheme()
    return (
        <Box sx={(theme: Theme) => (
            { display: 'flex', flexDirection: 'row', gap: '10px', borderRadius: '15px', padding: '0px 18px', height: '102px', background: theme.palette.common.white, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)' }
        )}>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Icons />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '10px', width: '80%' }}>
                {loading ? <>
                    <Skeleton animation="wave" sx={{ width: '60%' }} />
                    <Skeleton animation="wave" sx={{ width: '100%' }} />
                </> : <>
                    <Typography variant="h2" color={palette.text.primary} sx={{ lineHeight: '14px', fontWeight: '500' }}>{title}</Typography>
                    {!percent ? (
                        <Typography
                            variant="body_500"
                            color={color ? color : palette.text.primary}
                            sx={{ textWrap: 'nowrap' }}
                        >
                            {value}
                        </Typography>
                    ) : (
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                columnGap: "5px",
                                flexWrap: "wrap",
                            }}
                        >
                            <Typography
                                variant="body_500"
                                color={color ? color : palette.text.primary}
                                sx={{ textWrap: 'nowrap' }}
                            >
                                {value}
                            </Typography>
                            <Typography
                                variant="body_500"
                                color={color ? color : palette.text.primary}
                                sx={{ textWrap: 'nowrap' }}
                            >
                                ({percentageValue ? percentageValue.toFixed(2) : '0'}%)
                            </Typography>
                        </Box>
                    )}
                </>}

            </Box>
        </Box>
    )
}

const ResponsiveCard = (props: { align?: 'left' | 'right', title: string, value: string, color?: string }) => {
    const { palette } = useTheme()
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
            <Typography variant="h2" align={props.align ? props.align : 'left'} color={palette.text.secondary} sx={{ lineHeight: '14px', fontWeight: '500' }}>{props.title}</Typography>
            <Typography variant="body_500" color={props.color || palette.text.primary}>{props.value}</Typography>
        </Box>
    )
}
export default function CategoryWiseActionItems(): JSX.Element {
    const history = useHistory();
    const { state, pathname: pathName } = history.location;
    const { category } = state as { category: string };
    const { palette } = useTheme()
    const tabsList = ['Equity', 'Debt', 'Hybrid']
    const [selectedTab, setSelectedTab] = useState<string>(category);
    const dispatch = useDispatch();
    const [categoryWiseAmcData, setCategoryWiseAmcData] = useState<AMCPerformanceProductsRes>({} as AMCPerformanceProductsRes)
    const [categoryWiseAmcDataLoading, setCategoryWiseAmcDataLoading] = useState<boolean>(false)
    const [amcSortingObj, setAMCSortingObj] = useState<SortingObj>({ order: "desc", orderBy: "investedValue" })
    const [schemesLoader, setSchemesLoader] = useState<boolean>(false);
    const [cardLoader, setCardLoader] = useState<boolean>(false)
    const [cardValues, setCardValues] = useState<TotalCardValuesRes>({} as TotalCardValuesRes)
    const [topSchemesData, setTopSchemesData] = useState<GetTop10SchemesRes>({} as GetTop10SchemesRes);
    const [portfolioFilter, setPortfolioFilter] = useState<string | number>(1);
    const [portfolioLoader, setPortfolioLoader] = useState<boolean>(false)
    const [portfolioExposureData, setPortfolioExposureData] = useState<PortfolioExposureMFRes>({} as PortfolioExposureMFRes)
    const [marketCapData, setMarketCapData] = useState<MarketCapAllocationRes>({} as MarketCapAllocationRes)
    const [creditFilter, setCreditFilter] = useState<string | number>(1);
    const [creditLoader, setCreditLoader] = useState<boolean>(false)
    const [creditData, setCreditData] = useState<RatingAndMaturityRes>({} as RatingAndMaturityRes)
    const [issuerFilter, setIssuerFilter] = useState<string | number>(1);
    const [issueLoader, setIssueLoader] = useState<boolean>(false)
    const [issuerData, setIssuerData] = useState<IssuerCategoryRes>({} as IssuerCategoryRes)
    const [marketCapDataLoading, setMarketCapDataLoading] = useState<boolean>(false)
    const [quantitativeAnalysisData, setQuantitativeAnalysisData] = useState<Array<QuantitativeAnalysisData>>([])
    const [quantitativeAnalysisDataLoading, setQuantitativeAnalysisDataLoading] = useState<boolean>(false)

    const navState = state as navigationData
    const { investorClientId } = useSelector((store: RootStateType) => store.id);
    const {
        role = '',
        permissions = []
    } = useSelector((store: RootStateType) => store.auth);
    const {
        selectedPortfolio
    } = useSelector((store: RootStateType) => store.selectedPortfiolio);
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    const clientCode = navState?.clientCode || investorClientId || "";
    const initialRouter = pathName.split('/').filter((item) => item !== '')

    const rmRouterPath = isModuleAllowed({ value: "MFDashboard", compareArr: permissions, objKey: "permissonCode" }) ? (
        initialRouter[0] === 'product' ? [
            {
                name: 'Dashboard',
                path: '/dashboard',
                // warning: true
            },
            {
                name: 'Mutual Funds',
                path: `/${initialRouter[0]}/${initialRouter[1]}`,

            },
            {
                name: `${selectedTab || category}`,
                path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`,

            }

        ] : [
            {
                name: 'Dashboard',
                path: '/dashboard',
                // warning: true
            },
            {
                name: `${initialRouter[1]} ${selectedPortfolio.label ? `(${selectedPortfolio.label})` : ''}`,
                path: `/${initialRouter[0]}/${initialRouter[1]}`,
                state: {
                    clientCode: navState?.clientCode || ""
                }
            },
            {
                name: 'Mutual Funds',
                path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`,
                state: {
                    clientCode: navState?.clientCode || ""
                }
            },
            {
                name: `${selectedTab || category}`,
                path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}`,
                state: {
                    clientCode: navState?.clientCode || ""
                }
            }
        ]) : []

    const investorRouterPath = [
        {
            name: `Dashboard ${selectedPortfolio.label ? `(${selectedPortfolio.label})` : ''}`,
            path: '/investor-dashboard',
            // warning: true
        },
        {
            name: 'Mutual Funds',
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
            state: {
                clientCode: navState?.clientCode || ""
            }
        },
        {
            name: `${selectedTab || category}`,
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`,
            state: {
                clientCode: navState?.clientCode || ""
            }
        },

    ]
    const { iwappRmId } = useSelector((store: RootStateType) => store.id)
    const { investorRmId = "" } = useSelector((store: RootStateType) => store.sessionData)

    const totalCardValues = async (selectedCategory: string) => {
        try {
            setCardLoader(true);

            const cardValuesRes = await (dispatch(totalCardValuesApi({
                rmId: pathName.includes('product') ? `${iwappRmId}` : `${investorRmId}`,
                category: selectedCategory,
                clientCode,
                portfolioId: initialRouter?.[0].toLowerCase() === "product" ? '' : selectedPortfolio?.value,
                assetGroup: "MF"
            })) as unknown as Promise<TotalCardValuesRes>)
            setCardValues(cardValuesRes)

        } catch (e) {
            console.log("Error", e);
        } finally {
            setCardLoader(false);
        }
    }
    const fetchInvestorLevelAmcPerformance = async ({
        orderBy = 'investedValue',
        order = 'desc',
        selectedCategory
    }: {
        orderBy?: string;
        order?: Order;
        selectedCategory: string;
    }) => {
        try {
            setCategoryWiseAmcDataLoading(true);
            const amcPerformancePayload = {
                rmId: pathName.includes('product') ? `${iwappRmId}` : `${investorRmId}`,
                sortItem: orderBy,
                order: order,
                category: selectedCategory,
                clientCode,
                portfolioId: initialRouter?.[0].toLowerCase() === "product" ? '' : selectedPortfolio?.value,
                assetGroup: "MF"
            }
            const amcPerformanceRes = await (dispatch(getProductsAMCPerformance(amcPerformancePayload)) as unknown as Promise<AMCPerformanceProductsRes>)
            setCategoryWiseAmcData(amcPerformanceRes)
        } catch (e) {
            console.log("Error:", e)
        } finally {
            setCategoryWiseAmcDataLoading(false);
        }
    }

    const getPortfolioExposure = async (selectedCategory: string) => {
        try {
            setPortfolioLoader(true);
            const portfolioExposurePayload = {
                clientCode: clientCode,
                filter: portfolioFilter === 1 ? "Sectors" : "Companies",
                rmId: pathName.includes('product') ? `${iwappRmId}` : `${investorRmId}`,
                category: selectedCategory,
                portfolioId: initialRouter?.[0].toLowerCase() === "product" ? '' : selectedPortfolio?.value,
                assetGroup: "MF"
            }
            const portfolioAllocationRes = await (dispatch(portfolioExposureInCategory(portfolioExposurePayload)) as unknown as Promise<PortfolioExposureMFRes>);
            setPortfolioExposureData({ ...portfolioAllocationRes, result: { ...portfolioAllocationRes?.result } })
        } catch (e) {
            console.log("Error", e)
        } finally {
            setPortfolioLoader(false)
        }
    }

    const marketCap = async (selectedCategory: string) => {
        try {
            setMarketCapDataLoading(true);
            setMarketCapData({} as MarketCapAllocationRes);
            const marketCapPayload = {
                clientCode: clientCode,
                rmId: pathName.includes('product') ? `${iwappRmId}` : `${investorRmId}`,
                category: selectedCategory,
                portfolioId: initialRouter?.[0].toLowerCase() === "product" ? '' : selectedPortfolio?.value,
                assetGroup: "MF"
            }
            const marketCapRes = await (dispatch(getMarketCapAllocation(marketCapPayload)) as unknown as Promise<PortfolioExposureMFRes>);
            setMarketCapData({ ...marketCapRes, result: { ...marketCapRes?.result } })
        } catch (e) {
            console.log("Error", e)
        } finally {
            setMarketCapDataLoading(false)
        }
    }

    const getTopSchemes = async ({
        orderBy = 'amount',
        order = 'desc',
        selectedCategory
    }: {
        orderBy?: string;
        order?: Order;
        selectedCategory: string;
    }) => {
        try {
            setSchemesLoader(true);
            const topSchemesPayload = {
                rmId: pathName.includes('product') ? `${iwappRmId}` : `${investorRmId}`,
                // sortItem: orderBy,
                // order: order,
                category: selectedCategory,
                clientCode,
                portfolioId: initialRouter?.[0].toLowerCase() === "product" ? '' : selectedPortfolio?.value,
                assetGroup: "MF",
                isTop: true
            }
            const schemesRes = await (dispatch(top10Schemes(topSchemesPayload)) as unknown as Promise<GetTop10SchemesRes>)
            setTopSchemesData(schemesRes)
        } catch (e) {
            console.log('Error', e)
        } finally {
            setSchemesLoader(false);
        }
    }

    const fetchRatingAndMaturity = async (selectedCategory: string) => {
        try {
            setCreditLoader(true);
            const ratingMaturityPayload = {
                rmId: pathName.includes('product') ? `${iwappRmId}` : `${investorRmId}`,
                clientCode,
                category: selectedCategory,
                filter: creditFilter === 1 ? 'ratingName' : 'maturityYear',
                portfolioId: initialRouter?.[0].toLowerCase() === "product" ? '' : selectedPortfolio?.value,
                assetGroup: "MF"
            }
            const ratingAndMaturityRes = await (dispatch(getRatingAndMaturity(ratingMaturityPayload)) as unknown as Promise<RatingAndMaturityRes>)
            setCreditData({ ...ratingAndMaturityRes, result: { ...ratingAndMaturityRes?.result } })
        }
        catch (e) {
            console.log('Error', e);
        } finally {
            setCreditLoader(false);
        }
    }
    const fetchIssuerAllocation = async (selectedCategory: string) => {
        try {
            setIssueLoader(true);
            const issuerAllocationPayload = {
                rmId: pathName.includes('product') ? `${iwappRmId}` : `${investorRmId}`,
                clientCode,
                category: selectedCategory,
                filter: issuerFilter === 1 ? 'Issuer' : 'Instruments',
                portfolioId: initialRouter?.[0].toLowerCase() === "product" ? '' : selectedPortfolio?.value,
                assetGroup: "MF"
            }
            const issuerAllocationRes = await (dispatch(getIssuerCategoryAllocation(issuerAllocationPayload)) as unknown as Promise<IssuerCategoryRes>)
            setIssuerData({ ...issuerAllocationRes, result: { ...issuerAllocationRes?.result } })
        }
        catch (e) {
            console.log('Error', e);
        } finally {
            setIssueLoader(false);
        }
    }
    const fetchQuantitativeAnalysisData = async (currentTab: string) => {
        try {
            setQuantitativeAnalysisDataLoading(true)

            const payload = {
                rmId: pathName.includes('product') ? `${iwappRmId}` : `${investorRmId}`,
                clientCode: `${clientCode}`,
                category: currentTab,
                portfolioId: initialRouter?.[0].toLowerCase() === "product" ? '' : selectedPortfolio?.value,
                assetGroup: "MF"
            }

            const { result = [], message = "", isSuccess } = await (dispatch(getQuantitativeAnalysis(payload)) as unknown as Promise<GetQuantitativeAnalysisResponseBody>)

            if (isSuccess) {
                const modifiedRes = currentTab === "Debt" ? result.filter(obj => (obj?.amcname !== 'P/E' && obj.amcname !== 'P/B')) : result

                setQuantitativeAnalysisData(modifiedRes)
            } else {
                console.log(message)
            }


        } catch (error) {
            console.log("Error: ", error)
        } finally {
            setQuantitativeAnalysisDataLoading(false)
        }
    }

    useEffect(() => {
        selectedTab != 'Debt' && getPortfolioExposure(selectedTab)
    }, [portfolioFilter])

    useEffect(() => {
        selectedTab === 'Debt' && fetchRatingAndMaturity(selectedTab)
    }, [creditFilter])

    useEffect(() => {
        selectedTab === "Debt" && fetchIssuerAllocation(selectedTab)
    }, [issuerFilter])

    useEffect(() => {
        fetchInvestorLevelAmcPerformance({ selectedCategory: selectedTab });
        getTopSchemes({ selectedCategory: selectedTab })
        totalCardValues(selectedTab)
        selectedTab !== "Debt" && marketCap(selectedTab)
        fetchQuantitativeAnalysisData(selectedTab)
    }, [])


    const handleChangeTab = (item: string) => {
        setCreditFilter(1);
        setIssuerFilter(1);
        setSelectedTab(item)
        totalCardValues(item)
        fetchInvestorLevelAmcPerformance({
            selectedCategory: item
        })
        getTopSchemes({ selectedCategory: item })
        item != "Debt" && getPortfolioExposure(item)
        item != "Debt" && marketCap(item)
        item === "Debt" && fetchRatingAndMaturity(item)
        item === "Debt" && fetchIssuerAllocation(item)
        fetchQuantitativeAnalysisData(item)
    }

    const handleamcTableSorting = async (orderBy: string, order: Order) => {
        setAMCSortingObj({ orderBy, order })
        fetchInvestorLevelAmcPerformance({
            order,
            orderBy,
            selectedCategory: selectedTab
        })
    }

    return (
        <Box>

            <Box sx={{ width: '100%' }}>
                <BreadCrum array={![USER_ROLES.INVESTOR].includes(role) ? rmRouterPath : investorRouterPath} />
            </Box>
            {/* 4 Cards */}
            <Hidden only={'xs'}>
                <Grid container spacing={2} mt={'25px'}>
                    <Grid item width={'100%'} lg={3}>
                        <Card Icons={MoneyGrow}
                            title="Market Value"
                            value={cardValues?.result?.totalMarketValue < 0 ? `- ${formatCurrency({ value: Math.abs(cardValues?.result?.totalMarketValue), locale, currencyCode })}` : `${formatCurrency({ value: cardValues?.result?.totalMarketValue, locale, currencyCode })}`}
                            loading={cardLoader}
                            percent={false}
                        />
                    </Grid>
                    <Grid item width={'100%'} lg={3}>
                        <Card
                            Icons={CurrencyIcon}
                            title="Invested Value"
                            value={cardValues?.result?.totalInvestedValue < 0 ? `- ${formatCurrency({ value: Math.abs(cardValues?.result?.totalInvestedValue), locale, currencyCode })}` : `${formatCurrency({ value: cardValues?.result?.totalInvestedValue, locale, currencyCode })}`}
                            loading={cardLoader}
                            percent={false}
                        />
                    </Grid>
                    <Grid item width={'100%'} lg={3}>
                        <Card
                            Icons={ChartIcon}
                            title="Gain/Loss"
                            value={cardValues?.result?.gainLoss < 0 ? `- ${formatCurrency({ value: Math.abs(cardValues?.result?.gainLoss), locale, currencyCode })}` : `${formatCurrency({ value: cardValues?.result?.gainLoss, locale, currencyCode })}`}
                            color={cardValues?.result?.gainLoss >= 0 ? palette.success[800] : palette.error[500]}
                            loading={cardLoader}
                        />
                    </Grid>
                    <Grid item width={'100%'} lg={3}>
                        <Card
                            Icons={PercentageIcons}
                            title="Absolute Return %"
                            value={`${!Number.isNaN(Number(cardValues?.result?.percentage)) ?
                                Math.round(cardValues?.result?.percentage * 100) / 100 : '0'}%`}
                            color={(cardValues?.result?.percentage ?? 0) >= 0 ? palette.success[800] : palette.error[500]}
                            loading={cardLoader}
                            percent={false}
                        />
                    </Grid>
                </Grid>
            </Hidden>
            <Hidden smUp={true}>
                <Box sx={{ width: '100%', borderRadius: '15px', flexDirection: 'column', background: palette.background.paper, padding: '20px 18px', gap: '25px', mt: '30px' }}>
                    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                        <ResponsiveCard
                            title="Market Value"
                            value={cardValues?.result?.totalMarketValue < 0 ? `- ${formatCurrency({ value: Math.abs(cardValues?.result?.totalMarketValue), locale, currencyCode })}` : `${formatCurrency({ value: cardValues?.result?.totalMarketValue, locale, currencyCode })}`}
                        />
                        <ResponsiveCard
                            title="Invested Value"
                            value={cardValues?.result?.totalInvestedValue < 0 ? `- ${formatCurrency({ value: Math.abs(cardValues?.result?.totalInvestedValue), locale, currencyCode })}` : `${formatCurrency({ value: cardValues?.result?.totalInvestedValue, locale, currencyCode })}`}
                            align="right"
                        />
                    </Box>
                    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', mt: '25px' }}>
                        <ResponsiveCard
                            title="Gain/Loss"
                            value={cardValues?.result?.gainLoss < 0 ? `- ${formatCurrency({ value: Math.abs(cardValues?.result?.gainLoss), locale, currencyCode })}` : `${formatCurrency({ value: cardValues?.result?.gainLoss, locale, currencyCode })}`}
                            color={cardValues?.result?.gainLoss >= 0 ? palette.success[800] : palette.error[500]}
                        />
                        <ResponsiveCard
                            title="Absolute Return %"
                            value={`${!Number.isNaN(Number(cardValues?.result?.percentage)) ?
                                Math.round(cardValues?.result?.percentage * 100) / 100 : '0'}%`}
                            color={(cardValues?.result?.percentage ?? 0) >= 0 ? palette.success[800] : palette.error[500]}
                            align="right"
                        />

                    </Box>
                </Box>
            </Hidden>


            {/* Tabs */}
            <Box
                mt={'45px'}
                sx={{
                    display: 'flex', flexDirection: 'row', gap: '10px', paddingBottom: '15px', borderBottom: `1px solid #CDCDCD`, overflowX: 'auto', padding: '3px'
                }}
                role="tablist"
            >
                {tabsList.map((item, index) => <Button
                    component={'button'}
                    key={`${item}-${index}`}
                    onClick={() => handleChangeTab(item)}
                    aria-controls={item}
                    role="tab"
                    sx={{ padding: '5px 15px', background: selectedTab === item ? palette.primary[500] : 'transparent', borderRadius: '7px', outline: 'none', border: 'none', cursor: 'pointer' }}>
                    <Typography variant="body_500" color={selectedTab === item ? palette.textDark.primary : palette.text.secondary}
                        sx={(theme: Theme) => ({
                            fontFamily: theme.typography.fontFamily,
                            letterSpacing: '0.02px'
                        })}
                    >{item}</Typography>
                </Button>)}
            </Box>

            {/* Main Content */}


            <Grid container sx={{ mt: '8px' }} columnSpacing={3} rowSpacing={3}>

                {(selectedTab === 'Equity') &&
                    <>
                        <Grid item md={12} lg={6} sx={{ width: '100%' }}>
                            <Box sx={(theme: Theme) => ({
                                borderRadius: '20px',
                                padding: '25px 30px 45px 30px',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                                background: theme.palette.common.white,
                                height: '100%'
                            })}
                            >
                                <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Typography variant="h2" sx={{
                                        // marginBottom: '40px'
                                    }}>Market Cap Allocation</Typography>
                                </Box>
                                <Box sx={{
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}>
                                    {marketCapData?.isSuccess === false || marketCapData?.result?.data?.length === 0 ? <ErrorText /> :
                                        <CustomePieChart {...{ ...marketCapData?.result, isLoading: marketCapDataLoading, showSlider: true, title: 'Market Cap Allocation' }} />}

                                </Box>
                            </Box>
                        </Grid>
                        <Grid item md={12} lg={6} sx={{ mt: { xs: '25px', md: 0 }, width: '100%', }}>
                            <Box sx={(theme: Theme) => ({
                                borderRadius: '20px',
                                padding: '25px 30px 45px 30px',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                                background: theme.palette.common.white,
                                height: '100%'
                            })}>
                                <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Typography variant="h2" sx={{
                                        // marginBottom: '40px'
                                    }}>Portfolio Exposure</Typography>
                                    <CustomDropdown setFilterValue={setPortfolioFilter} IsLoading={portfolioLoader} options={[
                                        {
                                            "label": "Sector Allocation",
                                            "value": 1
                                        },
                                        {
                                            "label": "Company Exposure",
                                            "value": 2
                                        }
                                    ]} defaultValue={1} />

                                </Box>
                                <Box sx={{
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}>

                                    {portfolioLoader === false && (portfolioExposureData?.isSuccess === false || portfolioExposureData?.result?.data?.length === 0) ? <ErrorText /> :
                                        <CustomePieChart {...{ ...portfolioExposureData?.result, isLoading: portfolioLoader, showSlider: true, title: 'Portfolio Exposure' }} />}
                                </Box>
                            </Box>
                        </Grid>
                    </>
                }
                {(selectedTab === "Hybrid") &&
                    <>
                        <Grid item md={12} lg={6} sx={{ width: '100%' }}>
                            <Box sx={(theme: Theme) => ({
                                borderRadius: '20px',
                                padding: '25px 30px 45px 30px',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                                background: theme.palette.common.white,
                                height: '100%'
                            })}
                            >
                                <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Typography variant="h2" sx={{
                                        // marginBottom: '40px'
                                    }}>Market Cap Allocation</Typography>
                                </Box>
                                <Box sx={{
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}>

                                    {marketCapData?.isSuccess === false || marketCapData?.result?.data?.length === 0 ? <ErrorText /> :
                                        <CustomePieChart {...{ ...marketCapData?.result, isLoading: marketCapDataLoading, showSlider: true, title: 'Market Cap Allocation' }} />}
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item md={12} lg={6} sx={{ mt: { xs: '25px', md: 0 }, width: '100%', }}>
                            <Box sx={(theme: Theme) => ({
                                borderRadius: '20px',
                                padding: '25px 30px 45px 30px',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                                background: theme.palette.common.white,
                                height: '100%'
                            })}>
                                <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Typography variant="h2" sx={{
                                        // marginBottom: '40px'
                                    }}>Portfolio Exposure</Typography>
                                    <CustomDropdown setFilterValue={setPortfolioFilter} IsLoading={portfolioLoader} options={[
                                        {
                                            "label": "Sector Allocation",
                                            "value": 1
                                        },
                                        {
                                            "label": "Company Exposure",
                                            "value": 2
                                        }
                                    ]} defaultValue={1} />

                                </Box>
                                <Box sx={{
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}>
                                    {portfolioLoader === false && (portfolioExposureData?.isSuccess === false || portfolioExposureData?.result?.data?.length === 0) ? <ErrorText /> :
                                        <CustomePieChart {...{ ...portfolioExposureData?.result, isLoading: portfolioLoader, showSlider: true, title: 'Portfolio Exposure' }} />}

                                </Box>
                            </Box>
                        </Grid>
                    </>
                }
                {selectedTab === 'Debt' &&
                    <>
                        <Grid item md={12} lg={6} sx={{ width: '100%' }}>
                            <Box sx={(theme: Theme) => ({
                                borderRadius: '20px',
                                padding: '25px 30px 45px 30px',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                                background: theme.palette.common.white,
                                height: '100%'
                            })}
                            >
                                <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Typography variant="h2" sx={{
                                        // marginBottom: '40px'
                                    }}>{issuerFilter === 1 ? "Issuer Category Allocation" : "Instrument Category Allocation"}</Typography>
                                    <CustomDropdown setFilterValue={setIssuerFilter} IsLoading={issueLoader} options={[
                                        {
                                            "label": "Issuer Category Allocation",
                                            "value": 1
                                        },
                                        {
                                            "label": "Instrument Category Allocation",
                                            "value": 2
                                        },

                                    ]} defaultValue={1} />
                                </Box>
                                <Box sx={{
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}>
                                    {issueLoader === false && (issuerData?.isSuccess === false || issuerData?.result?.data?.length === 0) ? <ErrorText /> : <CustomePieChart {...{ ...issuerData?.result, isLoading: issueLoader, showSlider: true }} />}

                                </Box>
                            </Box>
                        </Grid>
                        <Grid item md={12} lg={6} sx={{ mt: { xs: '25px', md: 0 }, width: '100%', }}>
                            <Box sx={(theme: Theme) => ({
                                borderRadius: '20px',
                                padding: '25px 30px 45px 30px',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                                background: theme.palette.common.white,
                                height: '100%'
                            })}>
                                <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Typography variant="h2" sx={{
                                        // marginBottom: '40px',

                                    }}>{creditFilter === 1 ? "Credit Rating Allocation" : "Average Maturity Allocation"}</Typography>
                                    <CustomDropdown setFilterValue={setCreditFilter} IsLoading={creditLoader} options={[
                                        {
                                            "label": "Credit Rating Allocation",
                                            "value": 1
                                        },
                                        {
                                            "label": "Average Maturity Allocation",
                                            "value": 2
                                        },
                                    ]} defaultValue={1} />

                                </Box>
                                <Box sx={{
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}>
                                    {creditLoader === false && (creditData?.isSuccess === false || creditData?.result?.data?.length === 0) ? <ErrorText /> : <CustomePieChart {...{ ...creditData?.result, isLoading: creditLoader, showSlider: true, title: 'Credit Rating Allocation' }} />}

                                </Box>
                            </Box>
                        </Grid>
                    </>
                }
                {/* {selectedTab === 'Hybrid' &&
                    <>
                        <Grid item md={12} lg={6} sx={{ width: '100%' }}>
                            <Box sx={(theme: Theme) => ({
                                borderRadius: '20px',
                                padding: '25px 30px 45px 30px',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                                background: theme.palette.common.white,
                                height: '100%'
                            })}
                            >
                                
                                <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Typography variant="h2" sx={{
                                        marginBottom: '40px'
                                    }}>Market Cap Allocation</Typography>
                                </Box>
                                <CustomePieChart {...{ ...investorProfileFixture.assetAllocation, isLoading: false, showSlider: true }} />
                            </Box>
                        </Grid>
                        <Grid item md={12} lg={6} sx={{ mt: { xs: '25px', md: 0 }, width: '100%', }}>
                            <Box sx={(theme: Theme) => ({
                                borderRadius: '20px',
                                padding: '25px 30px 45px 30px',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                                background: theme.palette.common.white,
                                height: '100%'
                            })}>
                                <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Typography variant="h2" sx={{
                                        marginBottom: '40px'
                                    }}>Portfolio Exposure</Typography>
                                    <CustomDropdown setFilterValue={setPortfolioFilter} IsLoading={false} options={[
                                        {
                                            "label": "Sector Allocation",
                                            "value": 1
                                        },
                                        {
                                            "label": "Company Exposure",
                                            "value": 2
                                        }
                                    ]} defaultValue={1} />

                                </Box>
                                <CustomePieChart {...{ ...investorProfileFixture.assetAllocation, isLoading: false, showSlider: true }} />
                            </Box>
                        </Grid>
                    </>
                } */}
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InvestorLevelAMCPerformanceAnalysis
                        filters={false}
                        title='AMC Performance Analysis'
                        tableData={categoryWiseAmcData?.result}
                        isLoading={categoryWiseAmcDataLoading}
                        handleTableSorting={handleamcTableSorting}
                        sortingObj={amcSortingObj}
                        setSortingObj={setAMCSortingObj}
                    />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <TopScheme
                        title='Top 10 Schemes'
                        tableData={topSchemesData?.result?.topSchemes?.data}
                        isLoading={schemesLoader} />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <QuantitativeAnalysis title='Quantitative Analysis' tableData={quantitativeAnalysisData} isLoading={quantitativeAnalysisDataLoading} selectedTab={selectedTab} />
                </Grid>
            </Grid>
        </Box>
    )
}

interface TopSchemProps {
    title: string
    isLoading: boolean,
    tableData: any,
    selectedTab?: string
}

export const TopScheme = ({ title, tableData, isLoading }: TopSchemProps) => {
    const { palette, typography } = useTheme()
    return (
        <Box sx={{
            padding: '25px 30px 45px 30px',
            background: palette.common.white,
            borderRadius: '20px'
        }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h2" color={palette.text.primary}>
                    {title}
                </Typography>
            </Box>
            <Box mt={'20px'}>
                <CustomTable
                    loadingRowsNum={5}
                    isLoading={isLoading}
                    tableBody={
                        <TopSchemTable
                            tableBodyData={tableData || []}
                        />
                    }
                    tableData={tableData || []}
                    tableBodyLoaderRowCustomStyles={{
                        '& td:first-of-type': {
                            paddingLeft: "0px"
                        },
                    }}
                    tableHeaderData={TopSchemeTableHead}
                    tableHeadRowCustomStyles={{
                        '& th:first-of-type': {
                            paddingLeft: "0px"
                        }
                    }}
                    handleSort={
                        (orderBy: string, order: string) =>
                            console.log("Sort clicked", "orderBy", orderBy, "order", order)}
                    tableBodyCustomStyles={{
                        '& tr:last-child td': {
                            border: 0
                        }
                    }}
                    tableDataCount={tableData?.length || 0}
                    isPaginationVisible={false}
                />
            </Box>
        </Box>
    )
}

export const QuantitativeAnalysis = ({ title, tableData, isLoading, selectedTab }: TopSchemProps) => {
    const { palette, typography } = useTheme()

    return (
        <Box sx={{
            padding: '25px 30px 45px 30px',
            background: palette.common.white,
            borderRadius: '20px'
        }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h2" color={palette.text.primary}>
                    {title}
                </Typography>
            </Box>
            <Box mt={'20px'}>
                <CustomTable
                    loadingRowsNum={5}
                    isLoading={isLoading}
                    tableBody={
                        <QuantitativeAnalysisTable
                            tableBodyData={tableData}
                            selectedTab={selectedTab ?? ''}
                        />
                    }
                    tableData={tableData}
                    tableBodyLoaderRowCustomStyles={{
                        '& td:first-of-type': {
                            paddingLeft: "0px"
                        },
                    }}
                    tableHeaderData={QuantitativeAnalysisHead}
                    tableHeadRowCustomStyles={{
                        '& th:first-of-type': {
                            paddingLeft: "0px"
                        }
                    }}
                    tableBodyCustomStyles={{
                        '& tr:last-child td': {
                            border: 0
                        }
                    }}
                    tableDataCount={tableData.length}
                    isPaginationVisible={false}
                />
            </Box>
        </Box>
    )
}